import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { cond, startsWith } from 'src/utils';
import { useClasses } from 'src/lib/styles';
import { childrenPropType } from 'src/lib/prop-types';

const styles = {
  clickable: cond('cursor-pointer hover:shadow-xl transition-shadow duration-200'),
};

const isUrlInternal = startsWith('/');

export function Card({ url, external, className, children }) {
  const classes = useClasses(
    'w-full',
    'md:max-w-lg',
    'flex',
    'flex-col',
    'items-center',
    'p-10',
    'rounded-lg',
    styles.clickable(url),
    className,
  );

  if (url) {
    if (external) {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer" className={classes}>
          {children}
        </a>
      );
    }

    if (isUrlInternal(url)) {
      const to = url;
      return (
        <Link to={to} className={classes}>
          {children}
        </Link>
      );
    }

    return (
      <a href={url} className={classes}>
        {children}
      </a>
    );
  }

  return <div className={classes}>{children}</div>;
}

Card.propTypes = {
  url: PropTypes.string,
  external: PropTypes.bool,
  className: PropTypes.string,
  children: childrenPropType,
};

Card.defaultProps = {
  url: null,
  external: false,
  className: null,
  children: null,
};
